export enum RugbyLeagueFoulAttribute {
  Offside = 3010,
  DangerousPlay = 3011,
}
